import React from 'react';

import ProcoreLogo from 'icons/procore_logo.svg';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

export default function SelectionButton({ disabled = false, onClick }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'procore.fileDestination.components.inputFieldManagement.SelectionButton',
  });

  return (
    <div>
      <OutlinedButton
        color='grey'
        disabled={disabled}
        onClick={disabled ? () => {} : onClick}
        size='md'
      >
        <ProcoreLogo height='12px' width='12px' />
        <span className='tw-ml-2 tw-text-m tw-font-medium tw-tracking-auto'>
          {i18nT('text')}
        </span>
      </OutlinedButton>
    </div>
  );
}
